import * as React from 'react';
import SVGIcon from '../SVGIcon';

const CoachingPortalGraphic: React.FC = () => {
  return (
    <SVGIcon width="49" height="43" viewBox="0 0 49 43">
      <g fill="none">
        <path
          d="M24.5 12C27.2614 12 29.5 9.76142 29.5 7C29.5 4.23858 27.2614 2 24.5 2C21.7386 2 19.5 4.23858 19.5 7C19.5 9.76142 21.7386 12 24.5 12Z"
          stroke="#187A90"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M32.5 22C32.5 18.134 28.9183 15 24.5 15C20.0817 15 16.5 18.134 16.5 22"
          stroke="#187A90"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M12.5 18C14.7091 18 16.5 16.2091 16.5 14C16.5 11.7909 14.7091 10 12.5 10C10.2909 10 8.5 11.7909 8.5 14C8.5 16.2091 10.2909 18 12.5 18Z"
          stroke="#187A90"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M8.5 27C8.5 24.2386 10.2909 22 12.5 22C13.6046 22 14.6046 22.4477 15.3536 23.1967"
          stroke="#187A90"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M36.5 18C38.7091 18 40.5 16.2091 40.5 14C40.5 11.7909 38.7091 10 36.5 10C34.2909 10 32.5 11.7909 32.5 14C32.5 16.2091 34.2909 18 36.5 18Z"
          stroke="#187A90"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M40.5 27C40.5 24.2386 38.7091 22 36.5 22C35.3954 22 34.3954 22.4477 33.6464 23.1967"
          stroke="#187A90"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M18 32L24.5 26L31 32"
          stroke="#187A90"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M24.5 26V38"
          stroke="#187A90"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </SVGIcon>
  );
};

export default CoachingPortalGraphic;
